module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part",
    attrs: {
      "id": "part1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("PART ONE"), _c('br'), _c('span', {
    staticClass: "big2"
  }, [_vm._v("Lovers & Strangers")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Call no man foe, but never love a stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TELLA")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENSON")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Be not forgetful to entertain strangers: for thereby some have entertained angels unawares.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLE:")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EBREWS")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("My true-love hath my heart, and I have his,"), _c('br'), _vm._v("By just exchange one for the other given:"), _c('br'), _vm._v("I hold his dear, and mine he cannot miss,"), _c('br'), _vm._v("There never was a better bargain driven.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIP")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDNEY")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c3985d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/006-part1.vue
// module id = 72
// module chunks = 0